import { TFunction } from "i18next";

export type TaskProfileValue =
  | "standard"
  | "high_memory"
  | "xlarge"
  | "2xlarge";

const HIGH_MEMORY_JOB_TYPES = new Set<string>([
  "segments",
  "next_purchase",
  "client_elasticity",
  "price_elasticity",
  "market_basket",
  "seasonal_forecast",
  "store_transference",
  "promotions",
]);

const ALL_TASK_PROFILES: TaskProfileValue[] = [
  "standard",
  "high_memory",
  "xlarge",
  "2xlarge",
];

export function getRecommendedTaskProfile(jobType: string): TaskProfileValue {
  return HIGH_MEMORY_JOB_TYPES.has(jobType) ? "high_memory" : "standard";
}

export function isHighResourceTaskProfile(
  profile?: string | null
): profile is "xlarge" | "2xlarge" {
  return profile === "xlarge" || profile === "2xlarge";
}

export function getTaskProfileBaseLabel(
  t: TFunction,
  profile: TaskProfileValue | string
): string {
  switch (profile) {
    case "high_memory":
      return t("DataScienceJobs-TaskProfile.high_memory");
    case "xlarge":
      return t("DataScienceJobs-TaskProfile.xlarge");
    case "2xlarge":
      return t("DataScienceJobs-TaskProfile.2xlarge");
    case "standard":
    default:
      return t("DataScienceJobs-TaskProfile.standard");
  }
}

export function buildTaskProfileSelectOptions(
  t: TFunction,
  jobType: string
): { value: TaskProfileValue; label: string }[] {
  const recommended = getRecommendedTaskProfile(jobType);

  return ALL_TASK_PROFILES.map((profile) => {
    const baseLabel = getTaskProfileBaseLabel(t, profile);
    const label =
      profile === recommended
        ? `${baseLabel} ${t("DataScienceJobs-TaskProfile.recommended")}`
        : baseLabel;
    return { value: profile, label };
  });
}

export function isNonRecommendedTaskProfile(
  jobType: string,
  taskProfile?: string | null
): boolean {
  if (!taskProfile) {
    return false;
  }
  return taskProfile !== getRecommendedTaskProfile(jobType);
}
